var React = require('react');

function GreenCheckOutlined (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12.0293","cy":"12.7344","r":"9","fill":"white","stroke":"#1DD08B","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M8.0293 13.8556C8.96656 14.8496 10.4293 16.401 10.4293 16.401L16.0293 9.73438","stroke":"#1DD08B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

GreenCheckOutlined.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = GreenCheckOutlined;

GreenCheckOutlined.default = GreenCheckOutlined;
